export default __webpack_public_path__ + "static/media/Mont-Blanc-Light.931687a9.woff";